export const MapLoaderSizeToTextSize = {
    12: "caption-s",
    16: "caption-m",
    20: "body-m",
    24: "body-m",
    32: "body-l",
    48: "body-l",
};
